import React from "react";
import styled from "styled-components";
import { colors } from "./colors";
import { formatDay } from "./format";
import Card, { Title, Subtitle } from "./Card";
import SectionLossBars from "./SectionLossBars";
import RankShiftChart from "./RankShiftChart";
import CauseDeviceBreakdown from "./CauseDeviceBreakdown";

/** The site's losses by section, by ranking position, by cause and by device. */
export default function Breakdown({ fixture, drops, measure, onSectionSelect, onCauseSelect }) {
    const { site, sectionLosses, rankBuckets, deviceLosses } = fixture;
    return (
        <Card aria-labelledby="breakdown-heading">
            <Head>
                <Title id="breakdown-heading">Breakdown</Title>
                <Subtitle>Last 7 days vs. the week of {formatDay(site.baselineStart)}</Subtitle>
            </Head>
            <Parts>
                <SectionLossBars sections={sectionLosses[measure]} measure={measure} onSelect={onSectionSelect} />
                <RankShiftChart buckets={rankBuckets} baselineStart={site.baselineStart} />
                <CauseDeviceBreakdown drops={drops} measure={measure} devices={deviceLosses} onCauseSelect={onCauseSelect} />
            </Parts>
        </Card>
    );
}

const Head = styled.div`
    padding: 16px 20px;
    border-bottom: 1px solid ${colors.line};
`;

const Parts = styled.div`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    > * + * { border-left: 1px solid ${colors.line}; }
    @media (max-width: 1100px) {
        grid-template-columns: minmax(0, 1fr);
        > * + * { border-left: none; border-top: 1px solid ${colors.line}; }
    }
`;
